import type {
  RESPONSES_VISIBLE,
  RESPONSES_MANUALLY_VISIBLE,
} from '../../../constants';
import { RESPONSES_HIDDEN } from '../../../constants';

export const responseVisibilityToQuestionHideResults = (
  responseVisibility:
    | typeof RESPONSES_HIDDEN
    | typeof RESPONSES_VISIBLE
    | typeof RESPONSES_MANUALLY_VISIBLE,
) => {
  return responseVisibility === RESPONSES_HIDDEN;
};
